import styled from "styled-components";
import { Col } from "antd";

export const CompletedContributionsWrapper = styled(Col).attrs(()=>({
  id: 'completedContributions'
}))`
  width: 100%;
  height: ${props => (props.containerHeight ? props.containerHeight : "auto")};
  overflow-x: ${props => (props.overFlowX ? "scroll" : "hidden")};
  overflow-y: ${props => (props.overFlowY ? "scroll" : "hidden")};
  white-space: nowrap;
  position: relative;
`;

export const MaskDiv = styled.div`
  width: 9%;
  height: 98%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 19%
  );
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    width: 100%;
    height: 9%;
    bottom: 0;
    right: initial;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    display: none;
  }
`;
